export const INCENTIVES = `/v2/incentives`;
export const INCENTIVE_BY_ID = (id) => `/v2/incentives/${id}`;
